<template>
  <guest-layout>
    <template #header>
      Panduan Tahapan Pendaftaran Beasiswa
    </template>
    <Head title="Panduan Tahapan Pendaftaran Beasiswa" />

    <div class="container px-6 py-4 mx-auto mt-6 max-w-8xl">
      <div class="flex flex-col items-center gap-8 mb-12 lg:flex-row lg:items-start">
        <div class="w-full p-4 lg:w-1/2">
          <h1 class="mb-6 text-4xl font-extrabold leading-tight text-gray-900 md:text-5xl">
            Selamat Datang di <span class="text-blue-600">Beasiswa Cilegon Juare</span>
          </h1>
          <p class="mb-4 text-lg text-gray-700">
            Program beasiswa ini bertujuan untuk mendukung putra-putri terbaik Kota Cilegon
            dalam meraih pendidikan tinggi berkualitas. Raih kesempatan emas untuk mewujudkan
            cita-citamu!
          </p>
          <a v-if="!isReadOnly()" href="/register" class="inline-block px-8 py-3 text-lg font-semibold text-white transition duration-300 bg-indigo-600 rounded-lg shadow-md hover:bg-indigo-700">
            Daftar Sekarang
          </a>
          <a v-else href="/login" class="inline-block px-8 py-3 text-lg font-semibold text-white transition duration-300 bg-indigo-600 rounded-lg shadow-md hover:bg-indigo-700">
            Login
          </a>
        </div>

        <div class="w-full p-4 lg:w-1/2">
          <ImageSlider :images="sliderImages" />
        </div>
      </div>

    <div v-if="announcements && announcements.length > 0">
      <h2 class="w-full mb-8 text-2xl font-bold text-center text-gray-800">PENGUMUMAN</h2>
      <div class="flex flex-col w-full p-6 bg-slate-50 dark:bg-slate-900 gap-8">
        <div v-for="announcement in announcements" :key="announcement.id" class="w-full p-8 mx-auto bg-white shadow-md rounded-xl dark:bg-slate-800">
          <h2 class="mb-6 text-xl font-semibold text-center text-slate-800 dark:text-slate-100">
            {{ announcement.title }}
          </h2>
          <div class="mb-6 leading-relaxed text-justify text-slate-700 dark:text-slate-300 announcement-content" v-html="announcement.content"></div>
        </div>
      </div>
    </div>


      <h2 class="w-full my-8 text-2xl font-bold text-center text-gray-800">Panduan Tahapan Pendaftaran Beasiswa</h2>

      <div class="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 justify-items-center">
        <div
          v-for="(stage, index) in stages"
          :key="index"
          class="relative flex flex-col items-center w-full p-4 text-center bg-white rounded-lg shadow-lg"
        >
          <div class="flex items-center justify-center w-12 h-12 mb-4 text-xl font-bold text-white bg-gray-700 rounded-full">
            {{ stage.number }}
          </div>

          <h3 class="mb-2 text-lg font-semibold text-gray-800">{{ stage.title }}</h3>
          <p class="mb-4 text-sm text-gray-600">{{ stage.description }}</p>
          <a :href="stage.link" class="text-sm font-medium text-blue-600 hover:underline">
            {{ stage.linkText }}
          </a>

          <div
            v-if="index < stages.length - 1 && (index + 1) % 4 !== 0"
            class="absolute hidden h-0.5 transform -translate-y-1/2 lg:block"
            :class="{
              'w-full left-full': (index + 1) % 2 === 1 && (index + 1) % 4 !== 0,
              'w-full right-full': (index + 1) % 2 === 0 && (index + 1) % 4 !== 0
            }"
            style="transform: translateY(-50%)"
          />
        </div>
      </div>
    </div>
  </guest-layout>
</template>

<script>
import GuestLayout from '@/Layouts/GuestLayout.vue'
import { Head } from '@inertiajs/inertia-vue3'
import ImageSlider from '@/Shared/ImageSlider.vue'

export default {
  name: 'FrontIndex',
  components:{
    GuestLayout,
    Head,
    ImageSlider,
  },
  props: {
    stages: {
      type: Array,
      required: true,
      default: () => [],
    },
    announcements: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      sliderImages: [
        { src: '/images/image-1.jpeg', alt: 'Gambar Beasiswa' },
        { src: '/images/image-2.jpeg', alt: 'Gambar Kampus' },
        { src: '/images/image-3.jpeg', alt: 'Gambar Mahasiswa' },
      ],
    }
  },
  mounted() {
    if (this.$page.props.env === 'local') {
      this.$swal.fire({
        title: 'Perhatian',
        html: 'Website ini untuk keperluan percobaan dan pelatihan. Data akan direset secara berkala.<br><br>Gunakan website resmi untuk pendaftaran dan pelaporan di <a href="https://sicerdas.cilegon.go.id" target="_blank" class="text-indigo-600 underline font-bold">https://sicerdas.cilegon.go.id</a>.',
        icon: 'info',
        confirmButtonText: 'Mengerti',
        confirmButtonColor: '#4f46e5',
        allowOutsideClick: false
      });
    }
  },
}
</script>

